import { render } from "./PantryFoodTipData.vue?vue&type=template&id=083c43f0&ts=true"
import script from "./PantryFoodTipData.vue?vue&type=script&lang=ts"
export * from "./PantryFoodTipData.vue?vue&type=script&lang=ts"

import "./PantryFoodTipData.vue?vue&type=style&index=0&id=083c43f0&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__